import { render, staticRenderFns } from "./deliveryMethod.vue?vue&type=template&id=7d1fbd04&scoped=true&"
import script from "./deliveryMethod.vue?vue&type=script&lang=js&"
export * from "./deliveryMethod.vue?vue&type=script&lang=js&"
import style0 from "./deliveryMethod.vue?vue&type=style&index=0&id=7d1fbd04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fbd04",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
